import { Literal, Record, Static, String, Undefined, Union } from 'runtypes';

export const UrlParams = Record({
  accessToken: String,
  appOs: Union(Literal('ios'), Literal('android')),
  appVersion: String,
  authToken: String.Or(Undefined),
  phoneNumber: String.withConstraint(s => s.length === 10),
  preregisteredUserId: String.Or(Undefined),
  role: String,
  segmentAnonymousId: String
});

export type UrlParamsType = Static<typeof UrlParams>;
